// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { getBirthDateOptionMap, routerPush } from '@tcp/core/src/utils';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import {
  getError,
  getIsEmployee,
  getPersonalInfoErrorMessage,
} from './AddEditPersonalInformation.selectors';
import { getSuccess } from '../../MyProfile/container/MyProfile.selectors';
import AddEditPersonalInformationComponent from '../views';
import { updateProfile, updateProfileError } from './AddEditPersonalInformation.actions';
import internalEndpoints from '../../common/internalEndpoints';
import { updateProfileSuccess } from '../../MyProfile/container/MyProfile.actions';
import {
  getUserBirthday,
  getUserName,
  getUserLastName,
  getUserEmail,
  getUserPhoneNumber,
  getAssociateId,
  getAirmilesDetails,
  getPhoneCountryCode,
} from '../../User/container/User.selectors';
import { toastMessageInfo } from '../../../../common/atoms/Toast/container/Toast.actions';
import AddEditPersonalInformationSaga from './AddEditPersonalInformation.saga';
import AddEditPersonalInformationReducer from './AddEditPersonalInformation.reducer';
import {
  getIsInternationalPhoneNumber,
  getNewGlobalErrorMessage,
} from '../../../../../reduxStore/selectors/session.selectors';
import {
  hideError,
  setGlobalError,
} from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';
import {
  ACCOUNT_PROFILE,
  lblProfileSuccessMsg,
  ProfileInformationLabels,
} from '../../MyProfile/views/MyProfile.labels';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';

export class AddEditPersonalInformationContainer extends PureComponent {
  static propTypes = {
    successMessage: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    updateProfileAction: PropTypes.func.isRequired,
    messageStateChangeAction: PropTypes.func.isRequired,
    isEmployee: PropTypes.string.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    messageSuccessStateChangeAction: PropTypes.func.isRequired,
    toastMessage: PropTypes.func,
    personalInfoErrorMessage: PropTypes.string,
  };

  static defaultProps = {
    toastMessage: () => {},
    personalInfoErrorMessage: '',
  };

  constructor(props) {
    super(props);
    this.yearOptionsMap = getBirthDateOptionMap();
    const { labels, messageSuccessStateChangeAction, ...otherProps } = this.props;
    messageSuccessStateChangeAction(null);
    this.initialValues = this.getInitialValues(otherProps);
  }

  componentDidUpdate() {
    const { successMessage, errorMessage, personalInfoErrorMessage, setGlobalErrorAction } =
      this.props;
    if (successMessage === 'successMessage') {
      const successMsg = getLabelFromCopyOrFromTranslation(
        `${ACCOUNT_PROFILE}.${lblProfileSuccessMsg}`,
        ProfileInformationLabels
      );
      setGlobalErrorAction({ message: successMsg, type: 'success' });
      this.goBackToProfile();
    }

    if (errorMessage && personalInfoErrorMessage) {
      setGlobalErrorAction({ message: personalInfoErrorMessage, type: 'error' });
    }
  }

  componentWillUnmount() {
    const { messageStateChangeAction } = this.props;
    messageStateChangeAction(null);
  }

  updateProfileInformation = ({
    firstName,
    lastName,
    associateId,
    Email,
    phoneNumber,
    userBirthMonth,
    userBirthYear,
    airMilesAccountNumber,
    isEmployee,
    phoneCountryCode,
  }) => {
    const { updateProfileAction } = this.props;
    const newUserBirthday =
      userBirthMonth && userBirthYear ? `${userBirthMonth}|${userBirthYear}` : '';
    const associateIdValue = isEmployee && associateId ? associateId : null;
    updateProfileAction({
      firstName,
      lastName,
      email: Email,
      phone: phoneNumber,
      associateId: associateIdValue,
      userBirthday: newUserBirthday,
      airmiles: airMilesAccountNumber,
      phoneCountryCode,
    });
  };

  goBackToProfile = () => {
    routerPush(internalEndpoints.profilePage.link, internalEndpoints.profilePage.path);
    return null;
  };

  getInitialValues = (props) => {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      associateId,
      userBirthday,
      airMilesAccountNumber,
      phoneCountryCode,
    } = props;
    const birthdayArray = userBirthday ? userBirthday.split('|') : [];

    return {
      firstName,
      lastName,
      Email: email,
      phoneNumber,
      phoneCountryCode,
      associateId,
      airMilesAccountNumber,
      isEmployee: !!associateId,
      userBirthMonth: birthdayArray[0] || '',
      userBirthYear: birthdayArray[1] || '',
    };
  };

  render() {
    const {
      successMessage,
      errorMessage,
      onRequestClose,
      isEmployee,
      toastMessage,
      personalInfoErrorMessage,
      isInternationalPhoneNumberEnabled,
      newGlobalErrorMessageEnabled,
    } = this.props;

    return (
      <AddEditPersonalInformationComponent
        successMessage={successMessage}
        errorMessage={errorMessage}
        onSubmit={this.updateProfileInformation}
        onCancel={onRequestClose}
        toastMessage={toastMessage}
        isEmployee={isEmployee}
        birthMonthOptionsMap={this.yearOptionsMap.monthsMap}
        birthYearOptionsMap={this.yearOptionsMap.yearsMap}
        initialValues={this.initialValues}
        personalInfoErrorMessage={personalInfoErrorMessage}
        isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
        newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
      />
    );
  }
}

export const mapStateToProps = (state) => ({
  successMessage: getSuccess(state),
  errorMessage: getError(state),
  firstName: getUserName(state),
  lastName: getUserLastName(state),
  userBirthday: getUserBirthday(state),
  email: getUserEmail(state),
  phoneNumber: getUserPhoneNumber(state),
  associateId: getAssociateId(state),
  isEmployee: getIsEmployee(state),
  airMilesAccountNumber: getAirmilesDetails(state),
  personalInfoErrorMessage: getPersonalInfoErrorMessage(state),
  isInternationalPhoneNumberEnabled: getIsInternationalPhoneNumber(state),
  phoneCountryCode: getPhoneCountryCode(state),
  newGlobalErrorMessageEnabled: getNewGlobalErrorMessage(state),
});

export const mapDispatchToProps = (dispatch) => ({
  updateProfileAction: (payload) => {
    dispatch(updateProfile(payload));
  },
  messageSuccessStateChangeAction: (payload) => {
    dispatch(updateProfileSuccess(payload));
  },
  messageStateChangeAction: (payload) => {
    dispatch(updateProfileError(payload));
  },
  toastMessage: (errorMessage) => {
    dispatch(toastMessageInfo(errorMessage));
    dispatch(updateProfileError(null));
  },
  setGlobalErrorAction: (payload) => {
    dispatch(setGlobalError(payload));
  },
  hideErrorAction: (payload) => {
    dispatch(hideError(payload));
  },
});

const withReducer = withDynamicReducer({
  key: 'UpdateProfile',
  reducer: AddEditPersonalInformationReducer,
});
const withSaga = withDynamicSaga({ key: 'UpdateProfile', saga: AddEditPersonalInformationSaga });
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withReducer, withSaga, withConnect)(AddEditPersonalInformationContainer);
